import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Bushireforcorporateevents() {



const cardData =
{
  keyword: 'Bus Hire for Corporate Events Pune',
  heading: 'Sanavi Travels: Bus Hire for Corporate Events in Pune',
  headingDescription: 'Sanavi Travels offers professional and well-managed bus hire services for corporate events in Pune, ensuring seamless group transportation for offices, companies, and organizations with comfort, punctuality, and reliability as top priorities.',

  top: 'Top Corporate Event Travel Scenarios with Bus Hire in Pune',

  topPlaces: [
    {
      title: 'Corporate Meetings & Conferences',
      description: 'Bus hire for corporate meetings and conferences in Pune plays a crucial role in ensuring punctual and organized transportation for employees, management teams, and visiting delegates. Traveling together in a single bus eliminates coordination issues, late arrivals, and parking hassles at venues. Spacious seating allows professionals to relax, discuss agendas, and prepare mentally for meetings while on the move. This organized mode of transport reflects a company’s professionalism and commitment to employee convenience, especially during large-scale conferences, seminars, and annual business meets held across Pune.'
    },
    {
      title: 'Corporate Team Outings & Picnics',
      description: 'Corporate picnics and team outings are essential for employee bonding, stress relief, and team building. Hiring a dedicated bus ensures that all team members travel together, fostering interaction and camaraderie right from the journey. Large seating capacity, ample luggage space, and comfortable interiors make the travel experience enjoyable, while experienced drivers handle routes safely. This approach minimizes travel stress and allows employees to focus on enjoyment and collaboration rather than logistics.'
    },
    {
      title: 'Office Trips & Inter-Branch Travel',
      description: 'Companies with multiple branches often require group transportation for inter-branch meetings, audits, training sessions, and inspections. Bus hire offers a structured and cost-effective solution, allowing teams to move efficiently without relying on multiple vehicles. This not only saves cost but also ensures synchronized arrivals and departures, improving operational efficiency and time management.'
    },
    {
      title: 'Corporate Training Programs',
      description: 'Training programs often involve large groups of employees traveling to training centers, resorts, or offsite locations. Hiring a bus simplifies travel planning, ensures timely attendance, and provides a comfortable environment for employees before and after training sessions. Group travel also encourages discussion, knowledge sharing, and collaboration during transit.'
    },
    {
      title: 'Product Launches & Corporate Functions',
      description: 'Corporate functions such as product launches, annual celebrations, award ceremonies, and milestone events demand flawless logistics. Bus hire ensures smooth transportation for staff, partners, and guests, maintaining event schedules and enhancing overall guest experience. Coordinated group travel adds a touch of professionalism and organization to high-profile corporate events.'
    },
    {
      title: 'Employee Engagement Events',
      description: 'Employee engagement programs, including workshops, cultural events, and recreational activities, benefit greatly from bus transportation. Traveling together builds anticipation, encourages interaction, and ensures everyone reaches the venue safely and on time, making the event more successful.'
    },
    {
      title: 'Outstation Corporate Tours',
      description: 'Outstation corporate tours to nearby destinations require reliable and comfortable transport. Buses designed for long-distance travel offer smooth rides, adequate rest space, and safety features, making them ideal for extended journeys involving large teams.'
    },
    {
      title: 'Client & Partner Transportation',
      description: 'For corporate events involving external clients and partners, organized bus transportation reflects professionalism and hospitality. Guests can travel comfortably without worrying about navigation or parking, enhancing their overall experience with the organization.'
    },
    {
      title: 'Large-Scale Corporate Gatherings',
      description: 'Annual general meetings, corporate summits, and large gatherings often involve hundreds of participants. Bus hire helps manage large crowds efficiently, ensuring smooth entry and exit while reducing traffic congestion and logistical complexity.'
    },
    {
      title: 'Cost-Efficient Corporate Mobility',
      description: 'Hiring a bus for corporate events is more economical than arranging multiple cabs or reimbursements. It optimizes fuel costs, tolls, and time, making it a financially smart choice for organizations managing large teams.'
    }
  ],

  services: [
    {
      name: 'Bus Hire for Corporate Events Pune',
      description: 'Sanavi Travels provides end-to-end bus hire solutions for corporate events in Pune, catering to meetings, conferences, picnics, trainings, and celebrations. The service focuses on punctuality, comfort, and professional execution, ensuring employees and guests experience smooth and stress-free travel. Well-maintained buses, experienced drivers, and flexible scheduling make this service ideal for organizations of all sizes.'
    },
    {
      name: 'AC Bus for Corporate Events Pune',
      description: 'AC buses ensure a comfortable and climate-controlled environment, allowing professionals to travel relaxed and refreshed, especially during long journeys or hot weather conditions.'
    },
    {
      name: 'Non AC Bus Hire Corporate Events Pune',
      description: 'Non-AC buses provide budget-friendly options while maintaining safety, comfort, and reliability for corporate group travel.'
    },
    {
      name: 'Luxury Bus Hire Corporate Events Pune',
      description: 'Luxury buses offer premium interiors, push-back seating, and enhanced comfort, ideal for executive travel and high-profile corporate events.'
    },
    {
      name: '32 Seater Bus for Corporate Events Pune',
      description: '32 seater buses are suitable for mid-sized corporate teams, offering balanced seating capacity and easy maneuverability.'
    },
    {
      name: '35 Seater Bus Hire Corporate Events Pune',
      description: '35 seater buses accommodate larger groups, making them ideal for company-wide events and large gatherings.'
    },
    {
      name: 'Mini Bus on Rent Corporate Events Pune',
      description: 'Mini buses are perfect for small teams, management groups, and short-distance corporate travel.'
    },
    {
      name: 'Bus for Company Trips Pune',
      description: 'Dedicated company trip buses ensure organized travel for office outings, training visits, and recreational trips.'
    },
    {
      name: 'Bus for Corporate Meetings Pune',
      description: 'Ensures punctual and coordinated transportation for employees attending meetings and seminars.'
    },
    {
      name: 'Affordable Bus Rental Corporate Events Pune',
      description: 'Cost-effective rental plans help organizations manage budgets without compromising service quality.'
    },
    {
      name: 'Best Bus Service Corporate Events Pune',
      description: 'Sanavi Travels is recognized for reliability, professional drivers, and well-maintained buses.'
    },
    {
      name: 'Bus with Driver Corporate Events Pune',
      description: 'Experienced drivers ensure safe navigation, punctual arrivals, and smooth event-day logistics.'
    },
    {
      name: 'Bus for Corporate Picnic Pune',
      description: 'Ideal for transporting employees to picnic and outing destinations comfortably.'
    },
    {
      name: 'Bus for Wedding Corporate Events Pune',
      description: 'Suitable for transporting corporate guests attending wedding-related corporate gatherings.'
    },
    {
      name: 'Outstation Bus for Corporate Events Pune',
      description: 'Reliable outstation services support long-distance corporate travel and retreats.'
    }
  ],

  tableData: [
    ['AC Bus', 'Non AC Bus'],
    ['32 Seater', '35 Seater'],
    ['Corporate Meetings', 'Corporate Picnics'],
    ['Luxury Options', 'Budget Options'],
    ['Professional Drivers', 'Flexible Scheduling']
  ],

  whychoose: [
    {
      WhyChooseheading: 'Corporate Travel Expertise',
      WhyChoosedescription: 'Extensive experience in handling corporate transportation requirements with professionalism, precision, and reliability for events of all scales.'
    },
    {
      WhyChooseheading: 'Punctual & Organized Service',
      WhyChoosedescription: 'Strict adherence to schedules ensures timely arrivals and smooth coordination during corporate events.'
    },
    {
      WhyChooseheading: 'Comfort-Focused Fleet',
      WhyChoosedescription: 'Well-maintained buses with comfortable seating enhance employee satisfaction and travel experience.'
    },
    {
      WhyChooseheading: 'Professional Drivers',
      WhyChoosedescription: 'Licensed and trained drivers understand corporate expectations, safety norms, and route planning.'
    },
    {
      WhyChooseheading: 'Transparent Pricing',
      WhyChoosedescription: 'Clear pricing structures help companies plan budgets without hidden costs or surprises.'
    },
    {
      WhyChooseheading: 'Flexible Rental Plans',
      WhyChoosedescription: 'Customizable packages suit different corporate event durations and requirements.'
    },
    {
      WhyChooseheading: 'Scalable Solutions',
      WhyChoosedescription: 'Ability to manage transportation for small teams to large corporate gatherings.'
    },
    {
      WhyChooseheading: '24/7 Support',
      WhyChoosedescription: 'Dedicated support team ensures assistance before, during, and after corporate events.'
    }
  ]
};

const faqData = [
  {
    question: 'Do you provide bus hire for corporate events in Pune?',
    answer: 'Yes, Sanavi Travels specializes in providing professional bus hire services for corporate events in Pune, including meetings, conferences, picnics, and outstation programs, with reliable vehicles and experienced drivers.'
  },
  {
    question: 'Are AC buses available for corporate events?',
    answer: 'Yes, AC buses are available and recommended for corporate events to ensure comfort, especially during long journeys or summer seasons.'
  },
  {
    question: 'Can we hire buses for corporate picnics?',
    answer: 'Absolutely. We offer dedicated buses for corporate picnics and team outings, ensuring all employees travel together safely and comfortably.'
  },
  {
    question: 'Is luxury bus hire available for executives?',
    answer: 'Yes, luxury buses with premium interiors are available for executive travel and high-profile corporate events.'
  },
  {
    question: 'Do you provide outstation corporate bus services?',
    answer: 'Yes, we offer reliable outstation bus services for corporate retreats, trainings, and tours.'
  },
  {
    question: 'Are drivers experienced with corporate travel?',
    answer: 'Yes, our drivers are trained, professional, and experienced in handling corporate transportation requirements.'
  },
  {
    question: 'Can schedules and routes be customized?',
    answer: 'Yes, all routes, timings, and pickup points can be customized as per corporate event needs.'
  },
  {
    question: 'Is the service cost-effective for large teams?',
    answer: 'Yes, bus hire is one of the most economical solutions for transporting large corporate teams efficiently.'
  },
  {
    question: 'Are buses maintained regularly?',
    answer: 'Yes, all buses undergo regular maintenance, cleaning, and safety checks before every trip.'
  },
  {
    question: 'Is customer support available during events?',
    answer: 'Yes, we provide 24/7 customer support to ensure smooth coordination throughout corporate events.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sandeep Kulkarni',
    feedback: 'Sanavi Travels managed transportation for our corporate conference flawlessly. The bus was comfortable, arrived on time, and the driver handled everything professionally. It made our event logistics completely stress-free.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Neha Deshmukh',
    feedback: 'We hired buses from Sanavi Travels for our company picnic near Pune. The service was excellent, well-organized, and very comfortable for our entire team. Highly recommended for corporate events.',
    rating: 5
  }
];









































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];









// const jsonData = {
//   "@context": "https://schema.org",
//   "@type": "Product",
//   "name": "Bus Hire for Corporate Events Pune - Sanavi Travels",
//   "description": "Sanavi Travels offers bus rental services in Pune for corporate events. Choose AC, Non AC, luxury, 32 seater, 35 seater, or mini buses for company trips, corporate meetings, team outings, picnics, and outstation travel with a professional driver.",
//   "aggregateRating": {
//     "@type": "AggregateRating",
//     "bestRating": "5",
//     "worstRating": "1",
//     "ratingValue": "4.9",
//     "ratingCount": "4200+"
//   }
// };
const jsonData = {
  "@context": "https://schema.org",
  "@type": "Service",
  "@id":
    "https://www.sanavitravels.com/bus-hire-for-corporate-events-pune#service",

  "name": "Bus Hire for Corporate Events Pune",

  "serviceType": "Corporate Event Bus Rental",

  "description":
    "Sanavi Travels provides private buses on rent in Pune for corporate events, company outings, employee transportation, conferences, team-building activities, annual functions, corporate picnics and business events with professional drivers.",

  "provider": {
    "@type": "LocalBusiness",
    "@id": "https://www.sanavitravels.com/#business",
    "name": "Sanavi Travels",
    "url": "https://www.sanavitravels.com/",
    "telephone": "+91-7387507373"
  },

  "areaServed": {
    "@type": "City",
    "name": "Pune",
    "containedInPlace": {
      "@type": "State",
      "name": "Maharashtra",
      "containedInPlace": {
        "@type": "Country",
        "name": "India"
      }
    }
  },

  "url":
    "https://www.sanavitravels.com/bus-hire-for-corporate-events-pune"
};






  return (
    <div>
<Helmet>
  <title>
    Bus Hire for Corporate Events Pune | Corporate Bus Rental | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Hire private buses in Pune for corporate events, company outings, employee transportation, conferences, team-building activities and corporate picnics with professional drivers from Sanavi Travels."
  />

  <meta
    name="keywords"
    content="Bus Hire for Corporate Events Pune, Corporate Event Bus Pune, Corporate Bus Rental Pune, Bus Hire Pune, Company Event Bus Pune, Corporate Outing Bus Pune, Employee Transport Bus Pune, Corporate Picnic Bus Pune"
  />

  <link
    rel="canonical"
    href="https://www.sanavitravels.com/bus-hire-for-corporate-events-pune"
  />

  {/* Open Graph */}
  <meta
    property="og:type"
    content="website"
  />

  <meta
    property="og:title"
    content="Bus Hire for Corporate Events Pune | Sanavi Travels"
  />

  <meta
    property="og:description"
    content="Private bus hire in Pune for corporate events, company outings, employee transportation, conferences, team-building activities and corporate picnics."
  />

  <meta
    property="og:url"
    content="https://www.sanavitravels.com/bus-hire-for-corporate-events-pune"
  />

  <meta
    property="og:image"
    content="https://www.sanavitravels.com/images/bus-hire-for-corporate-events-pune.jpg"
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


{/* <Helmet>
  <title>
    Call : +91 7387507373 | Bus Hire for Corporate Events Pune | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Hire buses in Pune for corporate events with Sanavi Travels. AC, Non AC, luxury, 32 seater, 35 seater, and mini buses available for company trips, corporate meetings, team outings, picnics, and outstation travel with driver at affordable rates."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet> */}


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/bus-hire-for-corporate-events-pune.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Bushireforcorporateevents;